import cryptoRandomString from "crypto-random-string";
import { getDistance, convertDistance } from "geolib";
import { timestamp } from "../config/fbConfig";
// import { ENV } from '../config/envConfig';
import moment from "moment";
import axios from "axios";
import { firebaseRequestURI } from "../config/envConfig";

// export const firebaseRequestURI =
//   "https://us-central1-test-easychaw.cloudfunctions.net";
// export firebaseRequestURI;
// "https://us-central1-easychaw-2329c.cloudfunctions.net";

const loadCountries = (cb) => {
  axios
    .get("https://restcountries.eu/rest/v2/all")
    .then(({ data }) => {
      return cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

const toast = (toastInstance, { text, ...rest }) => {
  toastInstance
    .create({
      text: `<div style="display:flex;align-items:center;">
        <img 
          src="data:image/png;base64,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" 
          style="width:40px;margin-right:10px">
        <small>${text}</small>
      </div>`,
      ...rest,
    })
    .open();
};

const isEmpty = (value) => {
  if (value.trim() === "") {
    return true;
  } else {
    return false;
  }
};

const isValidEmail = (email) => {
  let re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(email);
};

const nameFile = (uid, file) => {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = `${month}`.length === 1 ? `0${month}` : month;
  let day = date.getDate();
  day = `${day}`.length === 1 ? `0${day}` : day;

  return `${year}${month}${day}-${cryptoRandomString({
    length: 10,
  })}-${uid}-${generateId(10)}.${file.name.split(".")[1]}`;
};

const uploadFile = (storageObject, path, uid, file, callback) => {
  const storageRef = storageObject.ref();

  const imageRef = storageRef.child(`${path}/${nameFile(uid, file)}`);

  imageRef
    .put(file)
    .then((snapshot) => {
      const path = snapshot.metadata.fullPath;
      snapshot.task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        callback(null, { path, URL: downloadURL });
      });
    })
    .catch((error) => {
      callback(error);
    });
};

const deleteFile = (storageObject, path, callback) => {
  const storageRef = storageObject.ref();

  const imageRef = storageRef.child(path);
  imageRef
    .delete()
    .then(() => callback(null))
    .catch((error) => callback(error));
};

const generateId = (length) => cryptoRandomString({ length });

const reverseGeocoding = (geocoder, location, callback) => {
  // Query the geocoder API to get human readable address
  let geocodingType =
    typeof location === "string" ? { address: location } : { location };
  geocoder.geocode(geocodingType, (results, status) => {
    // check if success, analyse and return address
    // if success, callback with  address
    let addressOrGeoCode;
    if (status === "OK") {
      // search for best possible address and sent;
      if (typeof location === "string") {
        addressOrGeoCode = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
      } else {
        addressOrGeoCode = results.find(({ types }) =>
          types.includes("street_address"),
        )
          ? results.find(({ types }) => types.includes("street_address"))
              .formatted_address
          : results.find(({ types }) => types.includes("route"))
              .formatted_address;
      }

      callback(null, addressOrGeoCode);
    } else {
      // Error
      callback(status);
    }
  });
};

const geoCodingApi = (query, cb) => {
  axios
    .get(
      `https://api.opencagedata.com/geocode/v1/json?q=${query}&key=7be4cddfcbd84f3fb49088172fbb4aa8`,
    )
    .then(
      ({
        data: {
          status: { code, message },
          results,
        },
      }) => {
        if (code !== 200) {
          return cb(message);
        }

        cb(null, results[0]);
      },
    )
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

const placeOrder = (firestore, orders, callback) => {
  let batch = firestore.batch();
  orders.forEach((order) => {
    let docRef = firestore.collection("orders").doc(generateId(7));
    batch.set(docRef, order);
  });

  batch
    .commit()
    .then(() => {
      callback(
        null,
        "Order placed, please check profile history to track order.",
      );
    })
    .catch((error) => {
      callback(error);
    });
};

const reduceProductStock = (token, uid, orders, products, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/reduceStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      orders,
      products,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// transact
const transact = (token, uid, transObj, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/transact`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      transObj,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// delete card
const deleteCard = (token, uid, authorizationCode, signature, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/deleteCard`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      authorizationCode,
      signature,
      token,
      uid,
    },
  })
    .then(({ data: { status, message } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, message);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// charge card
const chargeCard = (
  token,
  uid,
  authorizationCode,
  amount,
  email,
  reference,
  metadata,
  cb,
) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/chargeCard`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      authorizationCode,
      email,
      amount,
      reference,
      metadata,
      token,
      uid,
    },
  })
    .then(({ data: { status, message } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, message);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// Service charge
const serviceCharge = (
  cart,
  products,
  merchants,
  postDatedOrders,
  {
    percentageOrdersBelowAThousand = 2.55,
    percentageOrdersAboveAThousand = 3.95,
  },
  inclusive,
  deliveryMeans,
  fromWallet,
  settings,
) => {
  if (fromWallet) {
    return 0;
  } else {
    let count = 0;

    cart.forEach((cartObject) => {
      if (
        cartObject.packages
          .map(
            (p) =>
              totalProductPrice(
                products[p.productId].price,
                products[p.productId].discount,
              ) * p.count,
          )
          .reduce((a, b) => Number(a) + Number(b), 0) > 1000
      ) {
        count++;
      }
    });

    const total = cummulativeTotalProductPrice(cart, products);

    const totalDeliveryCharge = cart
      .map((cartObject) => {
        if (checkFreeDelivery(cartObject.packages, products)) {
          return 0;
        } else {
          return deliveryCharge(
            merchants[cartObject.merchantId].businessProfile.geoLoc,
            postDatedOrders[cartObject.merchantId].geoLoc,
            {
              defaultDeliveryCharge: settings
                ? (settings?.deliveryChargesPerCity?.[
                    merchants[cartObject.merchantId]?.businessProfile?.country
                  ]?.[
                    merchants[cartObject.merchantId]?.businessProfile?.state
                  ]?.[merchants[cartObject.merchantId]?.businessProfile?.city]
                    ?.deliveryCharge || settings?.defaultDeliveryCharge) *
                  deliveryMeans(cartObject.packages)
                : 500,
              perKmDeliveryCharge: settings
                ? (settings?.deliveryChargesPerCity?.[
                    merchants[cartObject.merchantId]?.businessProfile?.country
                  ]?.[
                    merchants[cartObject.merchantId]?.businessProfile?.state
                  ]?.[merchants[cartObject.merchantId]?.businessProfile?.city]
                    ?.kmPerDeliveryCharge || settings?.perKmDeliveryCharge) *
                  deliveryMeans(cartObject.packages)
                : 50,
            },
            inclusive(cartObject.packages),
          );
        }
      })
      .reduce((a, b) => a + b, 0);

    if (+total >= 5000) {
      return (
        125 +
        (1.95 / 100) * (+total + +totalDeliveryCharge) +
        (count - 1) * 35.37
      );
    } else if (+total >= 1000 && +total < 5000) {
      if (count === 0 || count === 1) {
        return (
          125 +
          (percentageOrdersAboveAThousand / 100) *
            (+total + +totalDeliveryCharge)
        );
      } else {
        return (
          125 +
          (percentageOrdersAboveAThousand / 100) *
            (+total + +totalDeliveryCharge) +
          (count - 1) * 35.37
        );
      }
    } else {
      return (
        (percentageOrdersBelowAThousand / 100) * (+total + +totalDeliveryCharge)
      );
    }
  }
};

// free delivery
const checkFreeDelivery = (packages, products) => {
  if (
    packages.filter((product) => products[product.productId].delivery === true)
      .length > 0
  ) {
    return false;
  } else {
    return true;
  }
};

// delivery charge
const deliveryCharge = (
  merchantGeoLoc,
  userGeoLoc,
  { defaultDeliveryCharge = 500, perKmDeliveryCharge = 50 },
  { inclusive, limit, zeroLimit },
) => {
  if (inclusive && !zeroLimit) {
    if (Math.ceil(getDistance(merchantGeoLoc, userGeoLoc) / 1000) <= limit) {
      return 0;
    } else {
      return (
        (Math.ceil(getDistance(merchantGeoLoc, userGeoLoc) / 1000) - limit) *
        perKmDeliveryCharge
      );
    }
  } else {
    if (Math.ceil(getDistance(merchantGeoLoc, userGeoLoc) / 1000) <= 2) {
      return defaultDeliveryCharge;
    } else {
      return (
        defaultDeliveryCharge +
        (Math.ceil(getDistance(merchantGeoLoc, userGeoLoc) / 1000) - 2) *
          perKmDeliveryCharge
      );
    }
  }
};

// Total product price (single)
const totalProductPrice = (productPrice, discount = 0) => {
  if (discount !== "" || +discount > 0) {
    let productPriceAfterDiscount =
      +productPrice - (+discount / 100) * +productPrice;
    return productPriceAfterDiscount;
  } else {
    return +productPrice;
  }
};

// Total products charge (cummulative)
const cummulativeTotalProductPrice = (cart, products) => {
  return cart
    .map((cartObject) =>
      cartObject.packages
        .map(
          (p) =>
            totalProductPrice(
              products[p.productId].price,
              products[p.productId].discount,
            ) * p.count,
        )
        .reduce((a, b) => Number(a) + Number(b), 0),
    )
    .reduce((a, b) => Number(a) + Number(b), 0);
};

// Total product price and delivery charge
const totalProductAndDeliveryCharge = (
  cart,
  products,
  merchants,
  postDatedOrders,
  inclusive,
  deliveryMeans,
  applyBonus,
  settings,
) => {
  return (
    cart
      .map((cartObject) =>
        cartObject.packages
          .map(
            (p) =>
              totalProductPrice(
                products[p.productId].price,
                products[p.productId].discount,
              ) * p.count,
          )
          .reduce((a, b) => Number(a) + Number(b), 0),
      )
      .reduce((a, b) => Number(a) + Number(b), 0) +
    cart
      .map((cartObject) => {
        if (checkFreeDelivery(cartObject.packages, products)) {
          return 0;
        } else {
          return deliveryCharge(
            merchants[cartObject.merchantId].businessProfile.geoLoc,
            postDatedOrders[cartObject.merchantId].geoLoc,
            {
              defaultDeliveryCharge: settings
                ? (settings?.deliveryChargesPerCity?.[
                    merchants[cartObject.merchantId]?.businessProfile?.country
                  ]?.[
                    merchants[cartObject.merchantId]?.businessProfile?.state
                  ]?.[merchants[cartObject.merchantId]?.businessProfile?.city]
                    ?.deliveryCharge || settings?.defaultDeliveryCharge) *
                  deliveryMeans(cartObject.packages)
                : 500,
              perKmDeliveryCharge: settings
                ? (settings?.deliveryChargesPerCity?.[
                    merchants[cartObject.merchantId]?.businessProfile?.country
                  ]?.[
                    merchants[cartObject.merchantId]?.businessProfile?.state
                  ]?.[merchants[cartObject.merchantId]?.businessProfile?.city]
                    ?.kmPerDeliveryCharge || settings?.perKmDeliveryCharge) *
                  deliveryMeans(cartObject.packages)
                : 50,
            },
            inclusive(cartObject.packages),
          );
        }
      })
      .reduce((a, b) => a + b, 0) -
    applyBonus()
  );
};

// paystack transfer charge
const payStackTransferCharge = (amount) => {
  if (+amount < 5000) {
    return 10;
  } else if (+amount >= 5000 && +amount < 50000) {
    return 25;
  } else {
    return 50;
  }
};

// Add bank
const addOrRemoveBank = (walletId, bankDetails, token, uid, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/addOrRemoveBank`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      walletId,
      bankDetails,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// make http request
const makeRequest = async (data, url) => {
  try {
    const {
      data: { status, message, success },
    } = await axios({
      method: "post",
      url: `${firebaseRequestURI}/${url}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    });

    return { status, success, message };
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message);
    } else if (error.request) {
      throw new Error(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(error.message);
    }
  }
};

// Resolve account number
const resolveAccountNumber = (accountNumber, bankCode, token, uid, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/resolveAccountNumber`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      accountNumber,
      bankCode,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// create transfer recipient
const createTransferRecipient = (
  { accountName, accountNumber, bankCode, token, uid, wallet },
  cb,
) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/createTransferRecipient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      accountNumber,
      bankCode,
      accountName,
      wallet,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data.recipient_code);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// initial transfer
const initiateATransfer = (
  { amount, recipient, reason, token, uid, retry },
  cb,
) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/initiateATransfer`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      amount,
      recipient,
      reason,
      token,
      uid,
      retry,
    },
  })
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// send OTP code
const sendOneTimePassword = ({ type, token, uid, reason }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/sendOneTimePassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      type,
      token,
      uid,
      reason,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// verify OTP code
const verifyOneTimePassword = ({ password, type, token, uid, reason }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/verifyOneTimePassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      password,
      type,
      token,
      uid,
      reason,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// send easychaw otp
const sendEasychawOneTimePassword = ({ token, uid, actions, details }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/sendEasychawOneTimePassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: details
      ? {
          actions,
          token,
          uid,
          details,
        }
      : {
          actions,
          token,
          uid,
        },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// verify Easychaw's OTP code
const verifyEasychawOneTimePassword = ({ password, token, uid }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/verifyEasychawOneTimePassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      password,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, success } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, success);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// Delete transfer recipient
const deleteTransferRecipient = ({ recipientCode, token, uid, wallet }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/deleteTransferRecipient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      recipientCode,
      token,
      wallet,
      uid,
    },
  })
    .then(({ data: { status, message } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, true);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// valiate function
// collection, property, value
const isAllowed = ({ token, uid, details }, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/isAllowed`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      token,
      details,
      uid,
    },
  })
    .then(({ data: { status, message } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, true);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

const isAllowedVendorsAndAgents = ({ token, uid, details }) => {
  return axios({
    method: "post",
    url: `${firebaseRequestURI}/isAllowedVendorsAndAgents`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      token,
      details,
      uid,
    },
  });
};

// fetch banks
const fetchBanks = (cb) => {
  axios
    .get("https://api.paystack.co/bank")
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// fund wallet
const fundWallet = (walletId, amount, token, uid, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/fw`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      walletId,
      amount,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// fund wallet
const fundAllWallets = (amount, token, uid, cb) => {
  axios({
    method: "post",
    url: `${firebaseRequestURI}/faw`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      amount,
      token,
      uid,
    },
  })
    .then(({ data: { status, message, data } }) => {
      if (!status) {
        return cb(message);
      }

      cb(null, data);
    })
    .catch((error) => {
      if (error.response) {
        cb(error.response.data.message);
      } else if (error.request) {
        cb(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        cb(error.message);
      }
    });
};

// check if user qualifies for 2% easychaw discounnt
const userQualifiedForEasychawDiscount = (cart, products) => {
  return (
    cart
      .flatMap((cartObject) => cartObject.packages)
      .filter(
        (p) =>
          totalProductPrice(
            +products[p.productId].price,
            +products[p.productId].discount,
          ) > 1000,
      )
      .map((p) => p.count)
      .reduce((a, b) => +a + +b, 0) >= 3
  );
};

// Calculate 2% discount
const calcEasychawDiscount = (isQualified, totalAmount) => {
  if (isQualified) {
    return +totalAmount - (2 / 100) * +totalAmount;
  } else {
    return +totalAmount;
  }
};

const preparationTimeComputed = (value) => {
  const days = Math.floor(+value / 60 / 24);
  const hours = Math.floor((+value - days * 60 * 24) / 60);
  const minutes = +value - Math.floor(+value / 60) * 60;
  const formatted = [];

  if (days > 0) {
    formatted.push(days + " " + (days > 1 ? "days" : "day"));
  }

  if (hours > 0) {
    formatted.push(hours + " " + (hours > 1 ? "hours" : "hour"));
  }
  if (minutes > 0) {
    formatted.push(minutes + " minutes");
  }
  return formatted.join(" ");
};

const handleErrors = ({ code, message }) => {
  switch (code) {
    // Auth Errors
    case "auth/email-already-exists":
      return message;
    case "auth/invalid-email":
      return message;
    case "auth/invalid-password":
      return message;
    case "auth/user-not-found":
      return message;
    case "auth/requires-recent-login":
      return message;

    // Storage Errors
    case "storage/unauthorized":
      return "Unauthorized";
    case "storage/unauthenticated":
      return "Unauthorized";
    case "storage/retry-limit-exceeded":
      return message;
    case "storage/canceled":
      return "Operantion cancelled";

    // Firestore Errors
    case "unavailable":
      return "Service Unavailable. This may be due to slow or no internet connection.";
    case "cancelled":
      return "The operation was cancelled";
    case "not-found":
      return message;
    case "already-exists":
      return message;
    case "permission-denied":
      return "Unauthorized";
    case "unauthenticated":
      return "Unauthorized";
    default:
      return "Something went wrong. Please check your connection and try again, if error persist, contact admin";
  }
};

const checksingleProductAvailableForOrder = (cartProductId, products) => {
  if (
    (products[cartProductId].available ||
      products[cartProductId].available === null ||
      products[cartProductId].available === undefined) &&
    (products[cartProductId].stocked === "" ||
      parseInt(products[cartProductId].stocked) >= 1)
  ) {
    return true;
  } else {
    return false;
  }
};

const checkProductsAvailabilityForOrder = (cart, products) => {
  let notAvailable = cart
    .flatMap((cartObject) => cartObject.packages)
    .filter(
      (p) =>
        products[p.productId].available === false ||
        (products[p.productId].stocked !== "" &&
          parseInt(products[p.productId].stocked) < 1),
    );

  if (notAvailable.length > 0) {
    return false;
  } else {
    return true;
  }
};

const deleteFiles = (storage, path, callback) => {
  storage
    .ref()
    .child(path)
    .delete()
    .then(() => callback(null, true))
    .catch((error) => callback(error));
};

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const notifyUser = (messages) => {
  // cordova.plugins.notification.local.schedule({
  //   title: messages[0].title,
  //   text: messages[0].body,
  //   badge: messages.length,
  //   foreground: true
  // });
  // let appE = {
  //   init: function () {
  //     document.addEventListener("deviceready", appE.ready);
  //   },
  //   ready: function () {
  //     appE.addListeners();
  //   },
  //   addListeners: function () {
  //     cordova.plugins.notification.local.on("click", function (notification) {
  //       navigator.notification.alert("clicked: " + notification.id);
  //       //user has clicked on the popped up notification
  //       console.log(notification.data);
  //     });
  //     cordova.plugins.notification.local.on("trigger", function (notification) {
  //       //added to the notification center on the date to trigger it.
  //       navigator.notification.alert("triggered: " + notification.id);
  //     });
  //   },
  //   addNote: function (ev) {
  //     let props = cordova.plugins.notification.local.getDefaults();
  //     //console.log(props);
  //     /**
  //      * Notification Object Properties - use it as a reference later on
  //      * id
  //      * text
  //      * title
  //      * every
  //      * at
  //      * data
  //      * sound
  //      * badge
  //      */
  //     let inOneMin = new Date();
  //     inOneMin.setMinutes(inOneMin.getMinutes() + 1);
  //     let id = new Date().getMilliseconds();
  //     let noteOptions = {
  //       id: id,
  //       title: "This is the Title",
  //       text: "Don't forget to do that thing.",
  //       at: inOneMin,
  //       badge: 1,
  //       data: {
  //         prop: "prop value",
  //         num: 42
  //       }
  //     };
  //     /**
  //      * if(props.icon){
  //       noteOptions.icon = './img/calendar-md-@2x.png'
  //     }
  //     if(props.led){
  //       noteOptions.led = '#33CC00'
  //     }
  //     if(props.actions){
  //       noteOptions.actions = [{ id: "yes", title: "Do it" }, { id: "no", title: "Nah" }]
  //     }
  //     **/
  //     cordova.plugins.notification.local.schedule(noteOptions, function(note){
  //       //this is the callback function for the schedule method
  //       //this runs AFTER the notification has been scheduled.
  //     });
  //     navigator.notification.alert("Added notification id " + id);
  //     cordova.plugins.notification.local.cancel(id, function () {
  //       // will get rid of notification id 1 if it has NOT been triggered or added to the notification center
  //       // cancelAll() will get rid of all of them
  //     });
  //     cordova.plugins.notification.local.clear(id, function () {
  //       // will dismiss a notification that has been triggered or added to notification center
  //     });
  //     cordova.plugins.notification.local.isPresent(id, function (present) {
  //       // navigator.notification.alert(present ? "present" : "not found");
  //       // can also call isTriggered() or isScheduled()
  //       // getAllIds(), getScheduledIds() and getTriggeredIds() will give you an array of ids
  //       // get(), getAll(), getScheduled() and getTriggered() will get the notification based on an id
  //     });
  //   }
  // };
  // appE.init();
};

const paystackTransactionCharge = (amount) => {
  const percentageCharge = (1.5 / 100) * +amount;
  if (+amount >= 2500) {
    return percentageCharge + 100;
  }

  return percentageCharge;
};

// ADMIN WALLET CALCULATIONS
// total transactions length
const totalTransactionsLength = (transactions) => transactions.length;

// total successfull transactions length
const totalSuccessFulTransactionsLength = (transactions) =>
  transactions.filter((t) => t.status === "Success").length;

// total failed transactions length
const totalFailedTransactionsLength = (transactions) =>
  transactions.filter((t) => t.status === "Failed").length;

// Total amount received through purchase from card
const totalAmountReceivedThroughPurchaseFromCard = (transactions) =>
  transactions
    .filter(
      (t) => t.type === "Received" && t.by === "Easychaw" && !t.from && !t.note,
    )
    .map((t) => t.amount)
    .reduce((a, b) => +a + +b, 0);

// total amount received through wallet purchase
const totalAmountReceivedThroughPurchaseFromWallet = (transactions) =>
  transactions
    .filter((t) => t.type === "Received" && t.from === "Easychaw Wallet")
    .map((t) => t.amount)
    .reduce((a, b) => +a + +b, 0);

// total deposit into wallet
const totalDeposits = (transactions) =>
  transactions
    .filter((t) => t.type === "Deposit")
    .map((t) => t.amount)
    .reduce((a, b) => +a + +b, 0);

const ECPOnDeposits = (t) =>
  t
    .filter((t) => t.type === "Deposit")
    .map((t) => +t.fee - paystackTransactionCharge(t.amount))
    .reduce((a, b) => +a + +b, 0);

const ECPOnWithdrawal = (t) =>
  t
    .filter((t) => t.type === "Withdrawn")
    .map((t) => +t.fee - payStackTransferCharge(t.amount))
    .reduce((a, b) => +a + +b, 0);

// total outbound
// This includes -
// total deposite by users
// merchants successful sales
// delivery successful sales
// users bonuses successful
// referral agents successful commission
const totalOutbound = (transactions) =>
  transactions
    .filter(
      (t) =>
        t.type === "Received" &&
        t.by !== "Easychaw" /*||
          t.type === 'Deposit'*/ &&
        t.status === "Success",
    )
    .map((t) => t.amount)
    .reduce((a, b) => +a + +b, 0);

// refunds
const totalRefunds = (t) =>
  t
    .filter(
      (t) =>
        t.type === "Received" &&
        t.by !== "Easychaw" &&
        t.reason === "Refund" &&
        t.status === "Success",
    )
    .map((t) => t.amount)
    .reduce((a, b) => +a + +b, 0);

// total withdrawal
const totalWithdrawal = (transactions) =>
  transactions
    .filter((transaction) => transaction.type === "Withdrawn")
    .map((transaction) => transaction.amount)
    .reduce((a, b) => a + b, 0);

// total paystacks fees on purchases
const totalPaystackFeesOnPurchases = (transactions) =>
  transactions
    .filter((t) => t.type === "Received" && t.by === "Easychaw" && !t.from)
    .map((t) => paystackTransactionCharge(t.amount))
    .reduce((a, b) => a + b, 0);

// total paystack fee on deposits
const totalPaystackFeesOnDeposits = (transactions) =>
  transactions
    .filter((t) => t.type === "Deposit")
    .map((t) => paystackTransactionCharge(t.amount))
    .reduce((a, b) => a + b, 0);

// total paystack fee o withdrawals
const totalPaystackFeesOnWithdrawals = (transactions) =>
  transactions
    .filter((transaction) => transaction.type === "Withdrawn")
    .map((t) => payStackTransferCharge(t.amount))
    .reduce((a, b) => a + b, 0);

// total Easychaw deposit
const totalEasychawDeposit = (t) =>
  t
    .filter((t) => t.note)
    .map((t) => +t.amount)
    .reduce((a, b) => +a + +b, 0);

// easychaw bonuses
const totalBonusesRewardedByEasychaw = (t) =>
  t
    .filter((t) => t.record)
    .map((t) => +t.amount)
    .reduce((a, b) => +a + +b, 0);

// total amount from uncompleted orders
const totalAmountFromUnSettledOrders = (orders) =>
  orders
    .map((o) => +o.totalUserAmount + +o.userDeliveryCharge)
    .reduce((a, b) => +a + +b, 0);

// wallet balance
const totalWalletBalance = (t, o) =>
  (totalAmountReceivedThroughPurchaseFromCard(t) || 0) +
  (totalEasychawDeposit(t) || 0) +
  (totalAmountReceivedThroughPurchaseFromWallet(t) || 0) -
  (totalPaystackFeesOnPurchases(t) || 0) -
  (totalOutbound(t) || 0) +
  (ECPOnDeposits(t) || 0) +
  (ECPOnWithdrawal(t) || 0) -
  (totalAmountFromUnSettledOrders(o) || 0);

const isMerchantOpen = (
  currentDateTime,
  operationDays,
  operationTimes,
  operationStartTime,
  operationCloseTime,
) => {
  const currentMoment = currentDateTime || timestamp.now()?.toDate();

  const day = moment(currentMoment).format("dddd");
  if (!operationDays || !operationDays.includes(day)) {
    return false;
  }

  // console.log(moment(currentDateTime).format('DD/MM/YYYY h:m:s a'));

  const amOrPm = moment(currentMoment).format("a");
  const hour = Number(moment(currentMoment).format("h"));
  const startHour =
    operationTimes?.[day]?.open?.split(" ")[0] ||
    operationStartTime.split(" ")[0];
  const startAmOrPm =
    operationTimes?.[day]?.open?.split(" ")[1] ||
    operationStartTime.split(" ")[1];
  const endHour =
    operationTimes?.[day]?.close?.split(" ")[0] ||
    operationCloseTime.split(" ")[0];
  const endAmOrPm =
    operationTimes?.[day]?.close?.split(" ")[1] ||
    operationCloseTime.split(" ")[1];

  // console.log(amOrPm, hour, startHour, startAmOrPm, endHour, endAmOrPm);

  if (amOrPm === "am") {
    if (
      startAmOrPm === "am" &&
      (Number(startHour) === 12 ||
        (hour !== 12 && Number(startHour) <= hour)) &&
      (endAmOrPm === "pm" ||
        (endAmOrPm === "am" &&
          endHour !== 12 &&
          (hour === 12 || hour < Number(endHour))))
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      (startAmOrPm === "am" ||
        (startAmOrPm === "pm" &&
          (Number(startHour) === 12 ||
            (hour !== 12 && Number(startHour) <= hour)))) &&
      endAmOrPm === "pm" &&
      Number(endHour) !== 12 &&
      (hour === 12 || hour < Number(endHour))
    ) {
      return true;
    } else {
      return false;
    }
  }
};

const getCurrentTime = (cb) => {
  axios
    .get("http://worldclockapi.com/api/json/utc/now")
    .then(({ data: { currentDateTime } }) => {
      cb(null, currentDateTime);
    })
    .catch((error) => {
      const currentDateTime = timestamp.now()?.toDate();
      // console.log(error);
      // cb(null, null);
      cb(null, currentDateTime);
    });

  // const currentDateTime = timestamp.now()?.toDate();
  // console.log(currentDateTime);
  // cb(null, currentDateTime);
};

export {
  getCurrentTime,
  isMerchantOpen,
  totalEasychawDeposit,
  totalBonusesRewardedByEasychaw,
  fundAllWallets,
  fundWallet,
  totalWalletBalance,
  totalPaystackFeesOnWithdrawals,
  totalAmountReceivedThroughPurchaseFromWallet,
  totalRefunds,
  totalPaystackFeesOnDeposits,
  totalPaystackFeesOnPurchases,
  totalWithdrawal,
  totalOutbound,
  totalDeposits,
  totalAmountReceivedThroughPurchaseFromCard,
  totalFailedTransactionsLength,
  totalSuccessFulTransactionsLength,
  totalTransactionsLength,
  paystackTransactionCharge,
  notifyUser,
  // imageCheck,
  deleteFiles,
  handleErrors,
  preparationTimeComputed,
  reverseGeocoding,
  loadCountries,
  toast,
  isEmpty,
  isValidEmail,
  uploadFile,
  generateId,
  deleteFile,
  placeOrder,
  geoCodingApi,
  reduceProductStock,
  transact,
  serviceCharge,
  deliveryCharge,
  totalProductPrice,
  checkFreeDelivery,
  fetchBanks,
  resolveAccountNumber,
  createTransferRecipient,
  deleteTransferRecipient,
  totalProductAndDeliveryCharge,
  userQualifiedForEasychawDiscount,
  cummulativeTotalProductPrice,
  calcEasychawDiscount,
  payStackTransferCharge,
  initiateATransfer,
  sendOneTimePassword,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
  verifyOneTimePassword,
  urlBase64ToUint8Array,
  addOrRemoveBank,
  checksingleProductAvailableForOrder,
  checkProductsAvailabilityForOrder,
  isAllowed,
  isAllowedVendorsAndAgents,
  deleteCard,
  chargeCard,
  firebaseRequestURI,
  makeRequest,
};
